export default function RefreshIcon() {
    return (
        <svg
            width="22"
            height="18"
            viewBox="0 0 22 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M8.66671 10.1666L6.33337 12.4999M6.33337 12.4999L8.66671 14.8333M6.33337 12.4999H13.9167C14.8832 12.4999 15.6667 11.7164 15.6667 10.7499V8.99988M13.3334 7.83293L15.6667 5.49959M15.6667 5.49959L13.3334 3.16626M15.6667 5.49959H8.08337C7.11688 5.49959 6.33337 6.2831 6.33337 7.24959V8.99988"
                stroke="#5A5F6A"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
